
import { Component, Vue, Prop} from 'vue-property-decorator';
import { namespace } from "vuex-class";   

import StepBase from "../StepBase.vue";
import OtherFormFilingLocation from "./OtherFormFilingLocation.vue";
import OtherForms from "./OtherForms.vue";
import CompleteOtherForms from "./CompleteOtherForms.vue";

import "@/store/modules/application";
const applicationState = namespace("Application");

import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages";
import { stepInfoType } from "@/types/Application";

@Component({
    components:{
        StepBase,
        OtherFormFilingLocation,
        OtherForms,
        CompleteOtherForms
    }
})

export default class OtherFormStep extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;
    
}
